/**
 * Logo Component
 * Displays the Dark Star Labs logo at the top center of the screen
 */

export function Logo({ className = '' }) {
  return (
    <div className={`dsl-logo-container ${className}`}>
      <a href="https://darkstarlabs.io" target="_blank" rel="noopener noreferrer">
        <img 
          src="/images/dslBrand/DSL Logo Light and Orange.png" 
          alt="Dark Star Labs" 
          className="dsl-logo"
        />
      </a>
    </div>
  )
}

export default Logo
